import React from 'react';
import { Character, Element } from '../types';

interface CharacterSidePanelProps {
  isOpen: boolean;
  character: Character;
  field: string;
  allElements: Element[];
  onClose: () => void;
  onUpdate: (character: Character) => void;
}

const CharacterSidePanel: React.FC<CharacterSidePanelProps> = ({
  isOpen,
  character,
  field,
  allElements,
  onClose,
  onUpdate
}) => {
  if (!isOpen) return null;

  return (
    <div className="side-panel-overlay">
      <div className="side-panel">
        <div className="side-panel-header">
          <h3>Edit {character.name} - {field}</h3>
          <button className="side-panel-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="side-panel-content">
          <p>Character side panel functionality coming soon...</p>
          <p>Field: {field}</p>
          <p>Available elements: {allElements.length}</p>
        </div>
      </div>
    </div>
  );
};

export default CharacterSidePanel; 